export enum MenuType {
    StandBy,
    WaitingArchiving,
    FollowFolder,
}

export class FolderMenuRefreshEvent {
    public constructor(
        public folderId: string,
        public menuType: MenuType,
        public toggleValue: boolean
    ) {}
}
